import React, { useState } from "react";
import BakeryLayout from "./BakeryLayout.tsx";
import BusinessLayout from "./BusinessLayout.tsx";

const App: React.FC = () => {
  const [isBakery, ] = useState(false);

  return (
    <div className="min-h-screen">
      {isBakery ? <BakeryLayout /> : <BusinessLayout />}
    </div>
  );
};

export default App;
